import React from 'react';
import { Link } from 'react-router-dom';
import { mockNews } from '../services/dataService';
import { getNewsImage } from '../utils/imageUtils';

/**
 * News List Page Component
 */
const NewsList = () => {
  return (
    <div className="container" style={{ paddingTop: '30px' }}>
      <h1 style={{ fontSize: '36px', marginBottom: '30px', textAlign: 'center' }}>
        📰 Space News
      </h1>
      <div className="grid">
        {mockNews.map(news => (
          <div key={news.id} className="card">
            <img 
              src={getNewsImage(news.id, news.headline)} 
              alt={news.headline}
              style={{ 
                width: '100%', 
                height: '200px', 
                objectFit: 'cover', 
                borderRadius: '8px', 
                marginBottom: '15px' 
              }}
              onError={(e) => {
                e.target.style.display = 'none';
              }}
            />
            <h2 style={{ color: 'var(--highlight-color)', marginBottom: '15px' }}>
              {news.headline}
            </h2>
            <p style={{ marginBottom: '10px' }}>
              <strong>Source:</strong> {news.source}
            </p>
            <p style={{ marginBottom: '10px' }}>
              <strong>Date:</strong> {news.date}
            </p>
            <p style={{ marginBottom: '15px', color: 'var(--text-dark)' }}>
              {news.summary}
            </p>
            <Link to={`/news/${news.id}`} className="btn btn-primary" style={{ display: 'block', textAlign: 'center' }}>
              Read Full Article
            </Link>
          </div>
        ))}
      </div>
    </div>
  );
};

export default NewsList;
